import {
    Props as AggregateDisplayProps,
    AggregateGrid,
} from "~/components/AggregateDisplay";

// // // //

export function PlatformIndividualAggregates(props: {
    aggregates: Array<AggregateDisplayProps>;
}) {
    const { aggregates } = props;

    return (
        <div className="mt-3">
            <AggregateGrid aggregates={aggregates} />
        </div>
    );
}
